import { useState, useEffect, useRef } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import WalletConnect from '@walletconnect/client/dist/umd/index.min.js'
import QRCodeModal from '@walletconnect/qrcode-modal'
import { API } from "aws-amplify"
import { LinkOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal, Spin, Drawer } from 'antd'
import { createNFTCertificates } from "../graphql/mutations"
import { getNFTCertificates } from "../graphql/queries"
import mockNFTs from '../mock/nft.json'
import './Home.css'
import NFTCertificateDetail from './NFTCertificateDetail'

export default () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [account, setAccount] = useState()
  const [fetching, setFetching] = useState(false)
  const [fetched, setFetched] = useState(false)
  const [getted, setGetted] = useState(false)
  const [nfts, setNfts] = useState([])
  const [selectedNft, setSelectedNft] = useState()
  const [NFTCertificate, setNFTCertificate] = useState()
  const [openLinkDrawer, setOpenLinkDrawer] = useState(false)
  const [pageKey, setPageKey] = useState()
  const [totalCount, setTotalCount] = useState(0)
  const [yourEns, setYourEns] = useState()
  const { confirm } = Modal

  const showConfirm = () => {
    confirm({
      title: 'Confirm the linking',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to choose this NFT for the printed artwork? This action cannot be undone.',
      onOk: linkItemToNFT,
      onCancel: () => {

      },
      okText: 'Yes',
      cancelText: 'No',
    });
  };

  const loadMoreRef = useRef()
  const { itemId } = useParams()
  const location = useLocation()

  const [connector, setConnector] = useState(
    new WalletConnect({
      bridge: 'https://bridge.walletconnect.org',
      qrcodeModal: QRCodeModal,
      autoConnect: true
    })
  )

  useEffect(() => {
    if (!getted) fetchItem()

    const observer = new IntersectionObserver(
      async (entries) => {
        if (entries[0].isIntersecting) {
          if (!fetching) fetchNFTs(account)
        }
      },
      {
        rootMargin: '20px',
      }
    )

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current)
    }
  })

  const fetchNFTs = async (account) => {
    setFetching(true)
    let path = `/nfts/${account}?pageKey=${pageKey}`

    if (process.env.REACT_APP_TESTNET == 'true') {
      path += '&testnet=1'
    }

    const { nfts: listNFT, pageKey: pageToken, totalCount: total } = await API.get('apicd3dea9f', path)

    setTotalCount(total)
    setPageKey(pageToken)
    setNfts([...nfts, ...listNFT])
    setFetched(true)
    setFetching(false)
  }

  const getENS = async (account) => {
    let path = `/nfts/${account}?pageKey=${pageKey}&ens=1&pageSize=1`

    if (process.env.REACT_APP_TESTNET == 'true') {
      path += '&testnet=1'
    }

    try {
      const { nfts: listEns } = await API.get('apicd3dea9f', path)

      setYourEns(listEns[0])
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchItem() {
    try {
      const response = await API.graphql({
        query: getNFTCertificates,
        variables: {
          id: itemId
        },
        authMode: 'AWS_IAM'
      })
      const item = response.data.getNFTCertificates
     
      if (item) {
        setNFTCertificate(item)
        getENS(item.walletAddress)
      } else {
        setIsModalOpen(true)
      }
    } catch (err) {
      console.log("ERROR:", err)
    } finally {
      setGetted(true)
    }
  }

  const linkItemToNFT = async () => {
    if (!selectedNft) return

    try {
      const response = await API.graphql({
        query: createNFTCertificates,
        variables: {
          input: {
            id: itemId,
            path: location.pathname + location.search,
            nftID: selectedNft.tokenId,
            nftName: selectedNft.title,
            nftImage: selectedNft.media[0]?.gateway,
            nftAddress: selectedNft.contract.address,
            contractSymbol: selectedNft.contract.symbol,
            walletAddress: account,
            description: selectedNft.description,
            createdAt: new Date(),
            updatedAt: new Date(),
          }
        },
        authMode: 'AWS_IAM'
      })

      setNFTCertificate(response.data.createNFTCertificates)
      setNfts([])
      setFetched(false)
    } catch (err) {
      console.log("ERROR: ", err)
    }
  }

  const onSelectNFT = (nft) => {
    setOpenLinkDrawer(true)
    setSelectedNft(nft)
  }

  const onCloseLinkDrawer = () => {
    setOpenLinkDrawer(false)
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const afterConnected = (account) => {
    setAccount(account)
    fetchNFTs(account)
    setIsModalOpen(false)
  }

  const walletConnect = async () => {
    // setConnect(true)
    if (!connector) return
    if (connector && !connector.connected) {
      // create new session
      await connector.createSession()
    }
    setConnector(connector)

    handleCancel()

    connector.on('connect', (error, payload) => {
      if (error) {
        throw error
      }
      const { accounts, chainId } = payload.params[0]

      afterConnected(accounts[0])
    })

    connector.on("session_update", async (error, payload) => {
      if (error) {
        throw error
      }

      console.log(payload)
    })

    connector.on('disconnect', (error, payload) => {
      if (error) {
        throw error
      }

      console.log(payload)
    })

    if (connector.connected) {
      const { accounts } = connector
      setAccount(accounts[0])
    }
  }

  const killSession = async () => {
    if (connector) {
      connector.killSession()
    }

    setAccount('')
  }

  const metaMaskConnect = async () => {
    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })

    if (accounts && accounts.length > 0) afterConnected(accounts[0])
  }

  function ListNFT() {
    return (
      <>
        {
          fetching && (
            <div className='font-bold text-stone-700 text-center'>
              <Spin size="small" />
              <span className='ml-2'>NFTs fetching...</span>
            </div>
          )
        }
        {
          fetched && (
            <div className='px-3'>
              <div className='text-start text-xl font-bold text-stone-700'>Your NFTs</div>
              <div className='text-start text-sm text-gray-400'>Showing { nfts.length }/{ totalCount } results</div>
            </div>
          )
        }
        <div className='py-5 px-3 grid grid-cols-2 gap-4 md:grid-cols-6 lg:grid-cols-8'>
          {
            nfts.map((nft) => {
              return (
                <div
                  key={nft.tokenId}
                  onClick={() => { onSelectNFT(nft) }}
                  className={`box-shadow bg-white bg-opacity-20 rounded-md cursor-pointer transition-all hover:scale-[1.02] ${ nft.tokenId === selectedNft?.tokenId ? 'scale-[1.02]' : ''}`}
                >
                  <div className='bg-slate-200 w-full aspect-square bg-center bg-cover rounded-t-lg' style={{backgroundImage: `url(${nft.media[0]?.gateway})`}}>
                  </div>
                  <div className='p-3 text-start text-stone-700'>
                    <div className='flex justify-between items-center'>
                      <span className='font-bold text-sm truncate'>{ nft.title || '---' }</span>
                      <div>
                        <span className='py-0.5 px-1 rounded-lg border-[1px] text-xs text-stone-500'>{nft.tokenType}</span>
                      </div>
                    </div>
                    <div className='text-xs mt-2 space-y-1'>
                      <div className='truncate'>NFT ID: <span className='font-bold'>{nft.tokenId}</span></div>
                      <div className='truncate text-gray-400 flex justify-between'>Address: <span>...{nft.contract.address.slice(-10)}</span></div>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
        {
          pageKey && (
            <div className='font-bold text-stone-700 text-center pb-4' ref={loadMoreRef}>
              <Spin size="small" />
            </div>
          )
        }
        {
          selectedNft && <Drawer
            title="Confirm the linking of the following items"
            closable={false}
            height='auto'
            placement='bottom'
            open={openLinkDrawer}
            onClose={onCloseLinkDrawer}
          >
            <div className='flex justify-center mb-6'>
              <div className='space-x-5 flex items-center'>
                <img src={selectedNft.media[0]?.gateway} className='w-[100px] rounded-lg inline-block' />
                <span><LinkOutlined className='text-gray-900' /></span>
                <span>Item <span className='font-bold uppercase'>{itemId}</span></span>
              </div>
            </div>
            <button
              onClick={showConfirm}
              disabled={!selectedNft?.tokenId}
              className='bg-primary w-full flex items-center justify-center py-3 px-5 rounded-lg font-bold space-x-1 text-white'
            >
              <LinkOutlined />
              <span>Link this NFT</span>
            </button>
          </Drawer>
        }
      </>
    )
  }

  return(
    <>
      <div className='min-h-screen bg-cover'>
        <div className='flex justify-between relative border-b-[1px] p-4 shadow'>
          <img src="/images/logo-DDERSI6Q.png" className='w-[90px]' />
          {
            account
            ? <span className='absolute rounded-full right-0 top-4 right-4 cursor-pointer bg-primary py-2.5 px-3 text-white'>{ account.slice(0, 6)}...{ account.slice(-6)}</span>
            : <button onClick={showModal} className='bg-primary text-white font-semibold rounded-lg px-3'>Connect Wallet</button>
          }
        </div>
        <div className='mt-5'></div>
        { NFTCertificate ? <NFTCertificateDetail NFTCertificate={NFTCertificate} address={account} yourEns={yourEns} /> : <ListNFT /> }
      </div>
      <Modal open={isModalOpen} title="" onCancel={handleCancel} footer={null} closable={false}>
        <div>
          <div className="walletItem text-center pb-5 pt-2 cursor-pointer" onClick={metaMaskConnect}>
            <div className="icon flex justify-center">
              <img className='w-[45px]' src="data:image/svg+xml;base64,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" alt="" />
            </div>
            <div className="text-2xl font-bold mt-3">MetaMask</div>
            <div className="text-lg text-[#a9a9bc]">Connect to your MetaMask Wallet</div>
          </div>
          <div className='border-b-[1px]'></div>
          <div className="walletItem text-center pt-5 pb-2 cursor-pointer" onClick={walletConnect}>
            <div className="icon flex justify-center">
              <img className='w-[45px]' src="data:image/svg+xml;base64,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" alt="" />
            </div>
            <div className="text-2xl font-bold mt-3">WalletConnect</div>
            <div className="text-lg text-[#a9a9bc]">Connect with Safepal, Trust and more..</div>
          </div>
        </div>
      </Modal>
    </>
  )
}
